export default "__VITE_ASSET__DTw52Th8__"